import Link from '@base/components/src/Link';

import { ValuedCustomerMessageProps } from './types';
import styles from './ValuedCustomerMessage.module.css';

const ValuedCustomerMessage = ({ phoneNumber }: ValuedCustomerMessageProps) => {
  return (
    <div id="valued-customer-message" className={styles.valuedCustomerMessage}>
      <span className={styles.valuedCustomerMessageTitle}>
        <div>Valued Customer!</div>
      </span>
      <span className={styles.valuedCustomerMessageDescription}>
        Please contact us at {''}
        <Link data-testid={'valued-customer-link'} classes={styles.valuedCustomerMessageLink} href={`tel:+1${phoneNumber.trim()}`}>
          {phoneNumber.trim()}
        </Link>{' '}
        {''}
        continue placing your order.
      </span>
    </div>
  );
};

export default ValuedCustomerMessage;
